import { Input } from "@windmill/react-ui";

const InputMobileWoCode = ({
  trigger,
  register,
  required,
  maxLength,
  minLength,
  pattern,
  defaultValue,
  name,
  label,
  type,
  placeholder,
}) => {
  const value = {
    valueAsNumber: false,
    required: required === false ? false : `${label} is required!`,
    pattern: {
      value: pattern,
      message: `Invalid ${label}!`,
    },
    maxLength: {
      value: maxLength,
      message: `Maximum Length ${maxLength}!`,
    },
    minLength: {
      value: minLength,
      message: `Minimum Length ${minLength}!`,
    },
  };

  const handleInput = (event) => {
    const inputValue = event.target.value;

    event.target.value = event.target.value.replace(/[^0-9]/g, "");
    const filteredValue = inputValue.replace(/[^0-9]/g, "");

    // Enforce maxLength
    event.target.value = filteredValue.slice(0, maxLength);
  };
  return (
    <>
      <div className={`flex flex-row`}>
        <Input
          {...register(`${name}`, value)}
          defaultValue={defaultValue}
          type={type}
          onInput={handleInput}
          placeholder={placeholder}
          name={name}
          autoComplete="off"
          onBlur={() => trigger(`${name}`)}
          className={`border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white`}
        />
      </div>
    </>
  );
};

export default InputMobileWoCode;
